import type { IAdViewUsedCarOfTheYear } from "@finn-no/adview-provider-frontend-types";
import { Button } from "@warp-ds/elements/react/button";

interface CarOfTheYearProps {
  carOfTheYear: IAdViewUsedCarOfTheYear;
}

export const CarOfTheYear = ({ carOfTheYear }: CarOfTheYearProps) => {
  return (
    <div className="border-2 rounded-8 mt-40 p-16 gap-16 flex items-center">
      <img src={carOfTheYear.logo.uri} alt={carOfTheYear.logo.altText} className="h-64 w-64 object-contain" />
      <div>
        <h2 className="t3">{carOfTheYear.title}</h2>
        <Button variant="link" href={carOfTheYear.link.uri} target="_blank" rel="noopener noreferrer">
          {carOfTheYear.link.title}
        </Button>
      </div>
    </div>
  );
};
